import { store } from '../store';
import { RESET_STATE } from '../types/stateTypes';

export const resetState = () => {
  store.dispatch({
    type: RESET_STATE,
  });
};
